export const subPageTitleScrollProgress = { current: 0 };
export const subPageTitleElementRef = { current: null as HTMLElement | null };
